import { makeStyles } from '@material-ui/core/styles';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { COLORS } from '../../../styles/constants';

export const useStyles = makeStyles(theme => ({
	chip: {
		width: props =>
			props.fullWidth &&
			`calc(100% / ${props.numberOfChips} - ${theme.spacing(1) * props.numberOfChips - theme.spacing(1)}px)`,
		minWidth: 50,
		backgroundColor: COLORS.BACKGROUND_INPUT,
		fontSize: theme.typography.body2.fontSize,
		'& .MuiChip-avatar': {
			width: 20,
			height: 20
		},
		'&:hover, &:focus': {
			backgroundColor: COLORS.BACKGROUND_INPUT_HOVER
		},
		'&:focus-visible': {
			outline: `2px solid`
		}
	},
	selectedChip: {
		backgroundColor: props =>
			props.variant === 'outlined'
				? 'default'
				: props.color === 'primary'
				? theme.palette.primary.main
				: theme.palette.secondary.main,
		border: props => (props.variant === 'outlined' ? `1px solid currentColor` : 0),
		color: props =>
			props.variant === 'outlined'
				? props.color === 'primary'
					? theme.palette.primary.main
					: theme.palette.secondary.main
				: theme.palette.common.white,
		'&:hover, &:focus': {
			backgroundColor: props =>
				props.variant === 'outlined'
					? 'default'
					: props.color === 'primary'
					? lighten(theme.palette.primary.main, 0.2)
					: lighten(theme.palette.secondary.main, 0.2)
		},
		'&:focus-visible': {
			outline: 'none'
		}
	},
	selectedChipMultiple: {
		'& .MuiChip-label': {
			paddingLeft: 10
		}
	},
	activeChip: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.common.white,
		'&:hover, &:focus': {
			backgroundColor: lighten(theme.palette.primary.main, 0.2)
		}
	},
	formLabel: {
		marginBottom: theme.spacing(1),
		color: theme.palette.common.black
	},
	formGroup: {
		display: 'flex',
		// justifyContent: 'center',
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginLeft: -theme.spacing(0.5),
		'& > *': {
			margin: `0 ${theme.spacing(0.5)}px`
		}
	}
}));
